module.exports = __webpack_public_path__ + "files/64491f9bb2169e6cff3cccb7bbe39899.png";